// Marketing-site i18n – bokstavtro portering fra canalboats.no
// Tre språk: NO (Bokmål), EN (Engelsk), DE (Tysk). Eneste kilde til
// tekst for hele publikums-nettstedet. Portalen/appen har egen i18n.

export const LANGS = [
  { code: "no", label: "Norsk", flag: "🇳🇴" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
];

export const TRANSLATIONS = {
  no: {
    nav: {
      home: "Hjem",
      fleet: "Vår flåte",
      experiences: "Opplevelser",
      canal: "Telemarkskanalen",
      coastline: "Kystlinjen",
      allInOne: "Alt-i-ett",
      about: "Om oss",
      faq: "FAQ",
      contact: "Kontakt",
      book: "Book nå",
      login: "Kundelogin",
    },
    footer: {
      tagline: "Verdens første elektriske charter-flåte i Telemark.",
      address: "Stangsgate 1, 3915 Porsgrunn",
      phone: "900 21 105",
      email: "post@canalboats.no",
      privacy: "Personvern",
      copyright: "© 2026 Canal Boats Telemark. Alle rettigheter reservert.",
      contactUs: "Kontakt oss",
      quickLinks: "Snarveier",
    },
    home: {
      eyebrow: "Miljøvennlig båtutleie i Telemark",
      heroTitle: "Book din yacht og utforsk Norges vakreste vannveier!",
      heroSub: "Velg dato og kom i gang:",
      ctaAvailability: "Sjekk ledighet",
      ctaFleet: "Se flåten",
      ctaAbout: "Om oss",
      section2Title: "Øko-luksus yachting for den moderne oppdageren",
      section2Body:
        "Møt verdens første elektriske charter-flåte – der luksus og bærekraft går hånd i hånd. Leie en yacht drevet av 100 % fornybar energi og oppdag Telemark – Norges skjulte perle for båtreisende.",
      pillars: [
        { title: "Oppdag Norge i miniatyr", body: "Nyt turen gjennom Telemarks vakre vannveier ombord i en elegant elektrisk yacht. Oppdag sjarmerende steder underveis." },
        { title: "En ny moderne kvalitet på båtliv", body: "Ingen motorstøy, ingen dieselos. Ta et øyeblikk for å koble av og oppleve omgivelsene med alle sansene." },
        { title: "Miljøvennlige motoryachter", body: "Med stillegående, utslippsfri fremdrift beveger båtene våre seg i takt med naturen." },
        { title: "Luksus og bærekraft", body: "Inviter dine kjære på en luksuriøs cruise i harmoni med naturen. Slapp av og nyt fredfulle stunder sammen." },
      ],
      fleetTitle: "Elektrisk flåte",
      fleetIntro:
        "Verdens første elektriske båtutleie inviterer deg på eventyr. Ta roret på en Greenline elektrisk cabin cruiser og legg ut på en unik reise.",
      fleetBody:
        "Oppdag Norge fra vannet — cruise stille gjennom historisk kanal, innsjøer og den vakre kysten. Enten det er en romantisk pause, familietur eller slow-travel-ferie med venner: våre helelektriske yachter tilbyr komfort, frihet og en unik måte å utforske Telemark.",
      toursTitle: "Opplev Norge i miniatyr!",
      toursSub: "Våre turer – Telemark er stedet hvor du kan oppleve den historiske Telemarkskanalen, majestetiske fjorder og en kystlinje full av små øyer – alt på én tur.",
      tourCards: [
        { tag: "Kystlinjen", title: "Kysteventyr på Norges Riviera", bullets: ["Øko-luksus", "Levende norsk kystlinje", "Fjorder, øyer og skjærgård", "Spa og avslapning"] },
        { tag: "Telemarkskanalen", title: "Telemarkskanalen – Norges skjulte perle", bullets: ["Perfekt for uteliv-elskere", "Fredfull avslapning", "Historisk kanalrute", "Utendørs aktiviteter og ro"] },
        { tag: "Alt-i-ett", title: "Alt-i-ett: Fjorder, kyst & kanal", bullets: ["For aktive oppdagere", "Fantastisk innlandsvann", "Pittoreske kystbyer", "Natur og sightseeing"] },
      ],
      reviewsTitle: "Din mening betyr noe",
      reviewsBased: "Basert på 19 anmeldelser",
      excellent: "UTMERKET",
    },
    fleet: {
      eyebrow: "Vår flåte",
      title: "Tilbring ferien om bord i verdens første helelektriske charter-flåte!",
      intro1: "Klar for å starte reisen?",
      intro2:
        "Flåten består av seks moderne Greenline-yachter (2021), tilgjengelig som bareboat-charter fra Porsgrunn i Telemark. Designet for reisende som verdsetter komfort, natur og frihet – disse cabin cruiserne lar deg utforske kysten og Telemarkskanalen i ditt eget tempo, stille, smidig og med stil.",
      intro3:
        "Hver yacht drives av en 50 kW (68 HK) elektrisk E-Drive-motor og kan lades via standard 230V landstrøm, som er tilgjengelig i de fleste marinaer. Et nettverk av hurtigladere er også tilgjengelig langs Telemarkskanalen og i Kragerø. Solcellepaneler på taket støtter systemene om bord.",
      intro4:
        "Elektrisk fremdrift betyr ingen eksosos og minimalt med støy – bare vannet, landskapet og din egen rytme. Velkommen til en ny standard for båtutleie i Norge.",
      chooseTitle: "Velg din favorittmodell",
      chooseSub: "Velg Greenline som passer din ferie – eventyrlysten eller komfort-orientert.",
      bookNow: "Book nå",
      checkAvail: "Sjekk ledighet",
    },
    gl33: {
      title: "Greenline 33",
      subtitle: "Elegant og prisbelønnet elektrisk båt for familie eller par.",
      lead:
        "Greenline 33 er en stilfull og prisbelønnet elektrisk båt, anerkjent i bransjen for design og innovasjon. Slank, elegant og lett å håndtere – den leverer myk og hyggelig cruising med et moderne miljøvennlig preg. Det kompakte skandinaviske interiøret er lyst, funksjonelt og innbydende.",
      pickup: "OBS: Overtakelsesdager er tirsdager og torsdager.",
      specsTitle: "Spesifikasjoner",
      specs: [
        "Antall soveplasser: 7",
        "Total kapasitet: 10 personer",
        "Front- og akterthrustere",
        "Elektrisk ankervinsj",
        "Solsenger på baugen",
        "Badeplatform",
        "Fullt utstyrt kjøkken",
        "Kjøleskap og fryser",
        "Induksjonstopp",
        "Mikrobølgeovn",
        "WiFi (på forespørsel)",
        "Dusj",
        "Toalett",
        "Aircondition",
        "Varmtvannsbereder",
        "300 l ferskvannstank",
        "140 l septiktank",
        "Brannalarm",
      ],
      descTitle: "Beskrivelse",
      desc: [
        "Gå om bord via den romslige akterplattformen, designet for uteliv. Nyt komfortable sitteplasser, teakbord, rikelig med lagring, og glidegardiner som beskytter mot vind og regn. Herfra er det bare noen få skritt til baugen med solsenger – det perfekte stedet for å slappe av og nyte utsikten.",
        "Skyvedører fra glass leder inn til et lyst, åpent interiør hvor moderne skandinavisk komfort møter smart design. Et løfte-vindu kobler kjøkkenet direkte til akterdekket – ideelt for morgener med kaffe eller solnedgangsnacks.",
        "Interiøret har to sofaer, justerbart bord og fantastiske 360° panoramavinduer. Én sofa konverteres til seng, og gir opptil tre sengeplasser i stuen. For koselige kvelder finner du TV, lydsystem og WiFi.",
        "Master-lugaren har en queen-size seng som kan konverteres til to enkeltsenger, samt innebygd oppbevaring. En køyeseng gir ekstra fleksibilitet for familier og grupper. Badet har elektrisk toalett, dusj og varmt vann.",
      ],
    },
    gl39: {
      title: "Greenline 39",
      subtitle: "Elegant elektrisk yacht med raffinert interiør og premium-opplevelse om bord.",
      lead:
        "Greenline 39 er en virkelig komfortabel og elegant elektrisk yacht, designet for reisende som verdsetter plass, stil og lettvint cruising. Romslig, godt utstyrt og vakkert avsluttet, tilbyr den en raffinert opplevelse om bord i premium-tur ånd.",
      pickup: "OBS: Overtakelsesdager er mandager, onsdager, fredager og lørdager.",
      specsTitle: "Spesifikasjoner",
      specs: [
        "Antall soveplasser: 6",
        "Total kapasitet: 10 personer",
        "Front- og akterthrustere",
        "Elektrisk ankervinsj",
        "Solsenger på baugen",
        "Badeplatform",
        "Pilotdør på styrbord",
        "Fullt utstyrt kjøkken",
        "Kjøleskap og fryser",
        "Induksjonstopp",
        "Mikrobølgeovn",
        "WiFi (på forespørsel)",
        "Dusj",
      ],
      descTitle: "Beskrivelse",
      desc: [
        "Yachten ønsker deg velkommen med komfortabel sofa og sitteområde, komplettert med teakbord og stoler. To store lagringsluker gir plass til bagasje, vannleker eller sportsutstyr.",
        "Akterplatformen senkes til badeplatform med stige – perfekt for svømming – og en utedusj gir ekstra komfort etter en dag på vannet. Gjennomsiktige vær-gardiner beskytter mot vind og regn.",
        "Interiøret har et lyst, glassfylt interiør med panoramautsikt. Skyvedører og løftevindu bak kjøkkenøya skaper en åpen konsept-layout som kobler interiør med dekk.",
        "Det åpne kjøkkenet er fullt utstyrt med induksjonstopp, kjøleskap med fryser, mikrobølgeovn og servise for opptil seks gjester. Stuen har sofa, bord og multimedia-system (TV med Chromecast, radio og høyttalere). Sofaen kan konverteres til dobbeltseng.",
        "Fremst leder en sentral korridor til master-lugaren, badet og andre gjeste-lugar. Master-lugaren har queen-size seng, rikelig oppbevaring og rolig atmosfære. Gjeste-lugaren har to enkeltsenger og garderobe.",
      ],
    },
    experiences: {
      canal: {
        title: "Telemarkskanalen – historisk kanal-cruising",
        lead:
          "Steg inn i eventyret og oppdag Norges skjulte perle: Telemarkskanalen — en historisk vannvei og levende bevis på at industri-arv kan eksistere i harmoni med naturen. Denne avslappende ruten tar deg gjennom små kanalbyer og betagende landskap.",
        body:
          "Nyt reisen om bord i en av våre helelektriske Greenline-yachter, som kombinerer moderne komfort med lettvint, stille cruising. Underveis finner du den perfekte balansen mellom uteaktiviteter, sightseeing og avslapning.",
        toursTitle: "Populære turer",
        tours: [
          { title: "7-natt Telemarkskanalen med Greenline 39", price: "Fra 2521 EUR", days: ["Dag 1 – Porsgrunn – Ulefoss", "Dag 2 – Ulefoss – Lunde", "Dag 3 – Lunde – Kviteseid", "Dag 4 – Kviteseid – Dalen", "Dag 5 – Dalen – Lårdal – Lunde", "Dag 6 – Lunde – Ulefoss", "Dag 7 – Ulefoss – Skien", "Dag 8 – Skien – Porsgrunn"] },
          { title: "7-natt Telemarkskanalen med Greenline 33", price: "Fra 1994 EUR", days: ["Dag 1 – Porsgrunn – Ulefoss", "Dag 2 – Ulefoss – Lunde", "Dag 3 – Lunde – Kviteseid", "Dag 4 – Kviteseid – Dalen", "Dag 5 – Dalen – Lårdal – Lunde", "Dag 6 – Lunde – Ulefoss", "Dag 7 – Ulefoss – Skien", "Dag 8 – Skien – Porsgrunn"] },
          { title: "4-natt Kanalen og Norsjø med Greenline 39", price: "Fra 1440 EUR", days: ["Dag 1 – Porsgrunn – Ulefoss", "Dag 2 – Ulefoss – First Camp Norsjø", "Dag 3 – First Camp Norsjø", "Dag 4 – First Camp Norsjø – Skien", "Dag 5 – Skien – Porsgrunn"] },
          { title: "4-natt Kanalen og Norsjø med Greenline 33", price: "Fra 1139 EUR", days: ["Dag 1 – Porsgrunn – Ulefoss", "Dag 2 – Ulefoss – First Camp Norsjø", "Dag 3 – First Camp Norsjø", "Dag 4 – First Camp Norsjø – Skien", "Dag 5 – Skien – Porsgrunn"] },
          { title: "3-natt Kanal-escape med Greenline 39", price: "Fra 1080 EUR", days: ["Dag 1 – Porsgrunn – Ulefoss", "Dag 2 – Ulefoss", "Dag 3 – Ulefoss – Skien", "Dag 4 – Skien – Porsgrunn"] },
          { title: "3-natt Kanal-escape med Greenline 33", price: "Fra 855 EUR", days: ["Dag 1 – Porsgrunn – Ulefoss", "Dag 2 – Ulefoss", "Dag 3 – Ulefoss – Skien", "Dag 4 – Skien – Porsgrunn"] },
        ],
        cta: "Book eventyret ditt nå",
      },
      coastline: {
        title: "Kysteventyr på Norges Riviera",
        lead: "Utforsk den vakre norske kystlinjen fra Porsgrunn til Kragerø – gjennom fjorder, arkipelag og pittoreske kystbyer.",
        body: "Denne turen er ideell for de som ønsker sol, bad, stille bukter og opplevelsen av kystlivet. Naviger i egen takt gjennom Langesund, Brevik, Kragerø, Risør og Tvedestrand.",
        highlights: ["Øko-luksus escape", "Levende norsk kystlinje", "Fjorder, øyer og arkipelag", "Spa og avslapning"],
      },
      allInOne: {
        title: "Alt-i-ett: Fjorder, kyst & kanal",
        lead: "Den ultimate reisen: kombinér den historiske Telemarkskanalen med en tur ut i skjærgården i én uforglemmelig ferie.",
        body: "Perfekt for aktive oppdagere som vil se alt. Anbefalt varighet er to uker for å nyte begge landskap i fullt monn.",
        highlights: ["For aktive oppdagere", "Fantastisk innlandsvann", "Pittoreske kystbyer", "Natur og sightseeing"],
      },
    },
    about: {
      eyebrow: "Om oss",
      title: "Elektrisk yacht-charter – ditt eventyr starter med Canal Boats Telemark!",
      lead:
        "Vi inviterer deg med på et fantastisk eventyr for å oppdage Telemark – en region på Norges sydkyst – om bord i en miljøvennlig elektrisk yacht. Vi er verdens første elektriske yacht-charter-selskap, med en flåte drevet utelukkende av fornybar energi.",
      pillars: [
        { title: "Beliggenhet", body: "Telemark er et unikt sted hvor du opplever stadig skiftende landskap – fra klippede fjord-kystlinjer til den menneskeskapte, betagende Telemarkskanalen, med krystallklare innsjøer og tette skoger som bakteppe." },
        { title: "Flåte", body: "Se hvordan harmoni med naturen kan gå hånd i hånd med luksuriøs komfort. En stille, utslippsfri båt, fullt utstyrt til premium-standard." },
        { title: "Opplevelse", body: "Oppdag en ny kvalitet på yachting om bord i et elektrisk fartøy i utrolige naturomgivelser. Ta et dypt pust, slapp av og nyt en ferie i en region full av skjulte perler." },
      ],
      storyTitle: "Vår historie",
      storySub: "Hva inspirerte oss?",
      storyText: [
        "Mitt navn er Ernst Terje, og i 2020 grunnla jeg Canal Boats Telemark med en klar visjon: å skape noe meningsfullt i Porsgrunn — min hjemby — og dele skjønnheten av en av verdens mest bemerkelsesverdige vannveier, rett utenfor stuedøra vår.",
        "Jeg vokste opp i Kragerø, og min tilknytning til sjøen begynte tidlig. Da jeg var seksten var somrene mine på vannet – lærte ved å gjøre – og utviklet dyp respekt for båtliv, natur og friheten som følger med livet til sjøs.",
        "Som tretti-åring kjøpte jeg min første 34 ft båt. År senere, som 46-åring, la jeg ut på livets eventyr om bord i Princess V46. Planen var enkel: å cruise fra Norge til Middelhavet gjennom Europas historiske kanalsystem.",
        "Reisen ble den beste ferien i mitt liv. Etter fire år og fire måneder returnerte jeg til Norge med uforglemmelige minner – og en ny idé jeg ikke kunne slippe. Den reisen ble grunnlaget for Canal Boats Telemark: et helelektrisk yacht-charter-selskap bygget rundt samme følelse av eventyr, komfort og frihet.",
      ],
      quote: "Reisen ble den beste ferien i mitt liv — og etter fire år og fire måneder returnerte jeg med uforglemmelige minner.",
      baseTitle: "Vår base",
      baseSub: "Vi ligger i Porsgrunn, Telemark",
      baseBullets: [
        "35 min med bil eller tog fra Torp lufthavn (TRF)",
        "2 timer med bil eller tog fra Oslo Gardermoen (OSL)",
        "Via E18 hvis du kommer fra fergehavner i Kristiansand, Larvik eller Sandefjord",
      ],
      baseBody:
        "Marinaen ligger ved elvebredden i sentrum, kun 5 minutters gange fra togstasjonen. Kontoret ligger 150 m fra marinaen. Du finner alle nødvendige fasiliteter på stedet, sammen med butikker og andre tjenester i nærheten.",
    },
    faq: {
      eyebrow: "Spørsmål og svar",
      title: "Ofte stilte spørsmål",
      subtitle: "Svar på de vanligste spørsmålene om båtutleie",
      intro:
        "Finner du ikke det du leter etter? Ta kontakt – vi hjelper deg gjerne med å planlegge den perfekte ferien.",
      searchPlaceholder: "Søk i FAQ…",
      contactCta: "Har du fortsatt spørsmål? Kontakt oss",
      categories: [
        {
          name: "1. BÅTOPPLEVELSE",
          items: [
            {
              q: "Må jeg ha båtførerbevis for å leie båt?",
              a: "I Norge avhenger båtførerbevis-krav av fødselsår. Er du født i 1980 eller senere må du ha gyldig båtførerbevis (norsk lov). Vårt sikkerhetskrav (gjelder alle): uansett fødselsår krever vi at fører har minst to sesongers båterfaring. Utenlandske sertifikater fra EØS er som regel gyldige. ICC godtas kun hvis det inkluderer kystnavigasjon (Resolusjon 40). Er du usikker, send oss et bilde av sertifikatet – vi verifiserer gratis.",
            },
            {
              q: "Får jeg opplæring?",
              a: "For å sikre at du føler deg trygg, gir vi grundig innføring ved ankomst: sikkerhetsrutiner, båtens utstyr, styrepult-instrumenter og praktiske tips. Innføringen tar ca. 1 time før du forlater marinaen. Ønsker du enda mer trygghet, tilbyr vi en valgfri 2-timers treningsøkt med vår kaptein – kan legges til under booking.",
            },
            {
              q: "Hva er fartsgrensene, og er noen strekninger lettere å navigere?",
              a: "Fartsgrense er 5 knop nær land (innen 50 m) – det er den vanligste begrensningen. Følg alltid sjømerker og lokal skilting. På Telemarkskanalen er fartsgrensen 5 knop. I kystfarvann gjelder samme grense nær land. Ved 5 knop varer batteriet typisk ca. 10 timer, maks fart er 10 knop.",
            },
            {
              q: "Kan jeg betale for å ha skipper om bord?",
              a: "Vi tilbyr ikke skipper for ukesturer, men en valgfri 2-timers treningsøkt med kaptein kan legges til ved booking. For dagsturer med kaptein: kontakt post@canalboats.no – tilgjengelighet varierer.",
            },
          ],
        },
        {
          name: "2. BOOKING",
          items: [
            {
              q: "Hvordan booker jeg en båt?",
              a: "Bruk vår bookingkalender for å finne datoer som passer. Alternativt kan du sjekke tilgjengelighet for spesifikke båtmodeller. Under online-bookingen velger du datoer, båtmodell og legger til valgfrie ekstra. Merk at rengjøringsgebyr alltid legges til. Du kan også sende booking-forespørsel via e-post, telefon eller chat. For endagsleie (10:00–22:00): kontakt oss direkte. Innsjekk og utsjekk er mandag til lørdag. Minimum leieperiode er 2 netter.",
            },
            {
              q: "Når er innsjekk og utsjekk?",
              a: "Innsjekk kl. 14:00, tar ca. 1 time. Utsjekk kl. 10:00 – båten må være klar for inspeksjon før 10:00. Sett alt utstyr tilbake på plass (spesielt tau og fendere) og kast avfall i containere ved marinaens inngang.",
            },
            {
              q: "Kan jeg få tidlig innsjekk eller sen utsjekk?",
              a: "Standard er 14:00 innsjekk og 10:00 utsjekk. Ta kontakt – vi vil gjøre vårt beste avhengig av dagens bookinger.",
            },
            {
              q: "Hvor henter og leverer jeg båten?",
              a: "Ved Canal Boats Telemark's marina i Porsgrunn (Porsgrunn Gjestehavn). Møt oss ved kontoret på Stangsgate 1, ca. 150 m fra marinaen. Kommer du med taxi eller mye bagasje: du er velkommen til å levere bagasjen ombord først, så gå til kontoret for innsjekk.",
            },
            {
              q: "Er det aldersgrense for å leie båt?",
              a: "Kapteinen må være minst 25 år.",
            },
            {
              q: "Hva er inkludert i leieprisen? Hva er ikke inkludert?",
              a: "Inkludert: båtleie, utstyr om bord (redningsvester, tau, fendere), fullt utstyrt kjøkken, sengetøy og håndklær til alle gjester, basis-forbruksvarer (såpe, kaffefiltre, salt/pepper), teakbord/stoler, forsikring, kanalbilletter for Telemarkskanalen 2026. Ikke inkludert: depositum/skadefritak (refunderbart), obligatorisk rengjøringsgebyr (250 EUR), ekstrautstyr (WiFi, SUP, innendørs parkering), lade-/strømkostnader (ca. €42–84 per uke).",
            },
            {
              q: "Er håndklær og sengetøy inkludert?",
              a: "Ja – sengetøy og håndklær for alle gjester er inkludert. Ekstra kan bestilles for et lite tillegg.",
            },
            {
              q: "Kan jeg bestille ekstrautstyr senere?",
              a: "Ja – ta kontakt via e-post eller telefon, betaling ved ankomst. For best tilgjengelighet anbefaler vi å bestille innendørs parkering og Wi-Fi på forhånd.",
            },
          ],
        },
        {
          name: "3. BETALING",
          items: [
            {
              q: "Hva koster det å leie en båt?",
              a: "Bruk booking-widgeten – prisen vises automatisk basert på datoer og båtmodell. Sesonger: Høysesong 21.06–14.08. Mellomsesong 01.05–20.06 og 15.08–04.10. Lavsesong 01.04–30.04 og 05.10–01.11.",
            },
            {
              q: "Hvilke betalingsalternativer har jeg?",
              a: "Du kan betale hele beløpet ved booking, eller dele i to avdrag: 35 % ved bekreftelse, resterende 65 % senest 42 dager før ferien starter. Kortbetaling via booking-systemet. For bankoverføring: kontakt oss.",
            },
            {
              q: "Hvilke betalingsmåter aksepterer dere?",
              a: "Visa, Mastercard, PayPal og Google Pay via nettsiden. Bankoverføring også mulig – kontakt oss for detaljer. Konto: Sparebanken Sør – 2801 55 18539, IBAN NO7928015518539, Swift SPSONO22XXX.",
            },
            {
              q: "Hvor mye er depositumet?",
              a: "Sikkerhetsdepositum er €3.000, betales ved innsjekk med kort eller kontant. Refunderes innen 7 virkedager etter utsjekk hvis båten leveres uskadd. Merk at kortbetaling har 3,6 % gebyr.",
            },
            {
              q: "Kan jeg kjøpe skadefritak?",
              a: "Ja – valgfritt skadefritak (redusert ansvar) koster €460. Reduserer ditt ansvar ved skade til €460 (ikke refunderbart). Se leiebetingelser for detaljer.",
            },
          ],
        },
        {
          name: "4. LADING OG INFRASTRUKTUR",
          items: [
            {
              q: "Hvor kan jeg lade båten?",
              a: "Ved marinaer med standard 16A ladepunkt – finnes i de fleste bryggene i Telemark, både langs kanalen og kysten. Hurtigladere (21 kW) finnes langs kanalen og i Kragerø Rørvik.",
            },
            {
              q: "Hva koster det å lade båten?",
              a: "Vanligvis inkludert i havneavgiften. Enkelte steder tilkommer ekstra kostnad, og hurtigladere har egen prising. Sjekk GoMarina eller Marina Booking apper.",
            },
            {
              q: "Hvor lang tid tar lading?",
              a: "Hurtiglading (400V/32A): ca. 3 timer til 80 %. Standard lading (230V/16A): la båten stå tilkoblet over natten. En vanlig kjørerdag (ca. 5 timer) bruker ca. 50 % av batteriet.",
            },
            {
              q: "Lengste avstand mellom ladepunkter?",
              a: "Mellom Kviteseid og Lunde – ca. 23,7 nautiske mil (43 km). Hurtigladere finnes i begge marinaer.",
            },
            {
              q: "Hva er rekkevidden på båten?",
              a: "Ved optimal cruise-hastighet på 5 knop kan du reise ca. 100 km (57,6 nm) – ca. 10 timers cruising. Solpaneler forsyner kun 12V-systemer om bord, ikke fremdrifts-batteriene.",
            },
          ],
        },
        {
          name: "5. GENERELL INFORMASJON",
          items: [
            {
              q: "Hva bør jeg huske å ta med?",
              a: "Komfortable sklisikre båtsko og vanntett tøy. Hansker kan være nyttig ved sluser (kan kjøpes hos oss). Flere butikker innen gangavstand – dagligvarer, vinmonopol, apotek. Vann-beholdere er unødvendig – drikkevann tilgjengelig i marinaen.",
            },
            {
              q: "Er fiske tillatt?",
              a: "Ja, med lokale regler. Kanalen har fine muligheter for ørret, abbor, røye, sik, gjedde og suter. Alle over 16 må ha gyldig fiskekort. Laks og sjøørret kun 1. juni–30. september, maks 2 per person per dag. Fiskekort kjøpes via inatur.no.",
            },
            {
              q: "Hvor tømmer jeg septiktanken?",
              a: "Telemarkskanalen: Hjellebrygga (Skien), Ulefoss gjestehavn, Kviteseid, Dalen og Akkerhaugen Vest. Kysten: Porsgrunn, Brevik, Langesund og Kragerø (fergeterminalen Stabbestad). Tømming i vannet er strengt forbudt – innsjøene er drikkevannskilder.",
            },
            {
              q: "Hvor mange sluser er det på Telemarkskanalen?",
              a: "8 slusesystemer med 18 slusekammer: Skien, Løveid, Ulefoss, Eidsfoss, Vrangfoss, Lunde, Kjeldal og Hogga. Kanalen er 105 km fra Skien til Dalen, med total løftehøyde 72 meter.",
            },
            {
              q: "Hva koster sluse-billettene?",
              a: "For sesongen 2026 er sluse-billetter INKLUDERT i båtleien – ingen ekstra sluseavgifter!",
            },
            {
              q: "Hvor lang tid tar Telemarkskanalen?",
              a: "Vi anbefaler ca. én uke for hele kanalen i rolig tempo. For kombinasjon kanal + kyst: minst to uker.",
            },
            {
              q: "Hvordan passerer jeg en sluse?",
              a: "En person forut, en akter. Sluseoperatøren gir deg fortøyningstau som du fester på motsatt side. Vi forklarer prosedyren ved innsjekk.",
            },
            {
              q: "Når er slusene åpne?",
              a: "21. juni–14. august. Daglig 09:00–18:00. Juli er travleste måned – vær tidlig ute (ca. 08:30). Passasjerbåter (MS Victoria og MS Ibsen) har alltid prioritet. Utenfor sesong: mulig med forhåndsavtale via kanalkontoret.",
            },
          ],
        },
        {
          name: "6. BELIGGENHET OG AVSTAND TIL BASE",
          items: [
            {
              q: "Hvor holder dere til?",
              a: "Porsgrunn i Telemark fylke. Hovedkvarter: Stangsgate 1, 3915 Porsgrunn. Gjestehavnen ligger 150 m fra kontoret.",
            },
            {
              q: "Hvordan kommer jeg til Porsgrunn?",
              a: "Fra Oslo Gardermoen (OSL) eller Oslo Torp (TRF). Bil: ca. 2,5 timer fra Oslo, 35 min fra Torp. Anbefaler direktetog – samme reisetid. Flere parkeringshus i Porsgrunn – vi tilbyr også innendørs parkering mot tillegg.",
            },
            {
              q: "Overnatting i Porsgrunn?",
              a: "Vi anbefaler Vic Hotel – sentralt beliggende, kort gange til marinaen. Book via vichotel.no og bruk kode CANBO for 15 % rabatt.",
            },
            {
              q: "Hvor kan jeg dra med båten?",
              a: "Vi anbefaler våre foreslåtte ruter: Telemarkskanalen, Kystlinjen eller Alt-i-ett. Alle reiser starter og slutter i Porsgrunn.",
            },
            {
              q: "Er det restriksjoner på hvor jeg kan kjøre?",
              a: "Nei – så lenge du returnerer båten til Porsgrunn i tide, er du fri til å utforske hvor du vil innen cruise-området.",
            },
          ],
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Ta kontakt med oss",
      sub: "Vi hjelper deg gjerne å planlegge den perfekte ferien.",
      form: {
        name: "Navn",
        email: "E-post",
        phone: "Telefon (valgfritt)",
        subject: "Emne",
        message: "Melding",
        send: "Send melding",
        sent: "Takk! Vi svarer så snart som mulig.",
        error: "Kunne ikke sende – prøv igjen eller e-post oss direkte.",
      },
      infoTitle: "Kontaktinformasjon",
      officeHours: "Åpningstider",
      officeHoursValue: "Man–Lør 09:00–17:00",
    },
    book: {
      eyebrow: "Book din tur",
      title: "Sjekk ledighet og send booking-forespørsel",
      sub: "Velg datoer og båtmodell – vi bekrefter innen 24 timer.",
      startDate: "Startdato",
      endDate: "Sluttdato",
      guests: "Antall gjester",
      boat: "Foretrukket båt",
      any: "Uansett",
      name: "Fullt navn",
      email: "E-post",
      phone: "Telefon",
      message: "Melding (valgfritt)",
      submit: "Send booking-forespørsel",
      success: "Takk! Vi tar kontakt for å bekrefte innen 24 timer.",
      error: "Kunne ikke sende – prøv igjen.",
      availableTitle: "Ledig neste 7 dager",
      loading: "Laster ledighet…",
    },
  },

  en: {
    nav: {
      home: "Home",
      fleet: "Our Fleet",
      experiences: "Experiences",
      canal: "Telemark Canal",
      coastline: "Coastline",
      allInOne: "All-in-One",
      about: "About Us",
      faq: "FAQ",
      contact: "Contact",
      book: "Book now",
      login: "Customer login",
    },
    footer: {
      tagline: "The world's first fully-electric charter fleet in Telemark.",
      address: "Stangsgate 1, 3915 Porsgrunn, Norway",
      phone: "+47 900 21 105",
      email: "post@canalboats.no",
      privacy: "Privacy",
      copyright: "© 2026 Canal Boats Telemark. All rights reserved.",
      contactUs: "Contact us",
      quickLinks: "Quick links",
    },
    home: {
      eyebrow: "Eco-Friendly Boat Rental in Telemark",
      heroTitle: "Book your yacht and explore Norway's stunning waterways!",
      heroSub: "Pick a date and get started:",
      ctaAvailability: "Check availability",
      ctaFleet: "See the fleet",
      ctaAbout: "About us",
      section2Title: "Eco-Luxury Yachting for the Modern Explorer",
      section2Body:
        "Meet the world's first electric charter fleet, where luxury and sustainability come together. Rent a yacht powered by 100% renewable energy and discover Telemark – a hidden gem for yachting travelers in Norway.",
      pillars: [
        { title: "Discover Norway in miniature", body: "Unwind as you cruise through Telemark's scenic waterways aboard an elegant, electric yacht." },
        { title: "New modern quality of boating", body: "No engine noise, no diesel fumes. Reconnect with nature and explore with all your senses." },
        { title: "Eco-friendly motor yachts", body: "Silent, emission-free propulsion — our boats move in tune with nature." },
        { title: "Luxury and sustainability", body: "Invite your loved ones for a luxurious cruise in harmony with nature." },
      ],
      fleetTitle: "Electric Fleet",
      fleetIntro:
        "The world's first electric boat charter company invites you on an adventure. Take the helm of a Greenline electric cabin cruiser and embark on an exceptional journey.",
      fleetBody:
        "Discover Norway from the water — cruise silently through historic canal, lakes and stunning coastline. Whether it's a romantic escape, family adventure or slow-travel holiday with friends, our fully electric yachts offer comfort, freedom and a unique way to explore Telemark.",
      toursTitle: "Experience Norway in miniature!",
      toursSub: "Our tours – Telemark is where you can experience the historic Telemark Canal, majestic fjords, and a coastline dotted with tiny islands – all in one trip.",
      tourCards: [
        { tag: "Coastline", title: "Coastline Adventure on the Norwegian Riviera", bullets: ["Eco-Luxury Escape", "Vibrant Norwegian Coastline", "Fjords, Islands and Archipelagos", "Spa and Relaxation"] },
        { tag: "Telemark Canal", title: "Telemark Canal Journey – Norway's Hidden Gem", bullets: ["Perfect for Outdoor Lovers", "Peaceful Relaxation", "Historic Canal Route", "Outdoor Activities and Tranquility"] },
        { tag: "All-In-One", title: "All-in-One Journey: Fjords, Coastline & Telemark Canal", bullets: ["For Active Explorers", "Stunning Inland Waterway", "Picturesque Coastal Towns", "Nature and Sightseeing"] },
      ],
      reviewsTitle: "Your opinion matters",
      reviewsBased: "Based on 19 reviews",
      excellent: "EXCELLENT",
    },
    fleet: {
      eyebrow: "Our Fleet",
      title: "Spend your holiday aboard the world's first all-electric charter fleet!",
      intro1: "Ready to start your journey?",
      intro2:
        "Our fleet includes six modern Greenline yachts (2021), available for bareboat charter from Porsgrunn in Telemark, Norway. Designed for travellers who value comfort, nature and freedom.",
      intro3:
        "Each yacht is powered by a 50 kW (68 HP) electric E-Drive engine and can be charged using a standard 230V shore power outlet. A network of fast chargers is also available along the Telemark Canal and in Kragerø.",
      intro4:
        "Electric propulsion means no exhaust fumes and minimal noise — just the water, the landscape and your own rhythm.",
      chooseTitle: "Choose your favourite model",
      chooseSub: "Pick the Greenline that matches your holiday style — adventure-ready or comfort-oriented.",
      bookNow: "Book now",
      checkAvail: "Check availability",
    },
    gl33: {
      title: "Greenline 33",
      subtitle: "Award-winning electric boat, perfect for family getaways or holidays for two.",
      lead:
        "Greenline 33 is a stylish and award-winning electric boat, recognized in the industry for its design and innovation. Sleek, elegant and easy to handle, it delivers smooth and enjoyable cruising with a modern eco-friendly touch.",
      pickup: "Please note: Pick up days are Tuesdays and Thursdays",
      specsTitle: "Specifications",
      specs: [
        "Number of berths: 7",
        "Total capacity: 10 people",
        "Thrusters front and rear",
        "Electric anchor winch",
        "Sun loungers on the bow",
        "Bathing platform",
        "Fully equipped kitchen",
        "Refrigerator and freezer",
        "Induction hotplate",
        "Microwave",
        "Wifi (on demand)",
        "Shower",
        "Toilet",
        "Airconditioning",
        "Water heater",
        "300 l fresh water tank",
        "140 l septic tank",
        "Fire alarm",
      ],
      descTitle: "Description",
      desc: [
        "Step aboard via the spacious aft deck. Comfortable seating, teak table and generous storage. Sliding doors lead to an open, bright interior.",
        "Modern Scandinavian style meets smart design. A lift-up window connects the kitchen directly to the aft deck for an effortless social flow.",
        "Interior has two sofas, adjustable table and 360° panoramic windows. One sofa converts into a bed, giving up to three sleeping places in the living area.",
        "Master cabin: queen-size bed convertible to two singles, built-in storage, bunk bed for extra flexibility. Full bathroom with electric toilet, shower and hot water.",
      ],
    },
    gl39: {
      title: "Greenline 39",
      subtitle: "Elegant electric yacht with refined interior and premium onboard experience.",
      lead:
        "Greenline 39 is a truly comfortable and elegant electric yacht, designed for travellers who value space, style and effortless cruising.",
      pickup: "Please note: Pick up days are Mondays, Wednesdays, Fridays, and Saturdays.",
      specsTitle: "Specifications",
      specs: [
        "Number of berths: 6",
        "Total capacity: 10 people",
        "Thrusters front and rear",
        "Electric anchor winch",
        "Sun loungers on the bow",
        "Bathing platform",
        "Pilot door on starboard",
        "Fully equipped kitchen",
        "Refrigerator and freezer",
        "Induction hotplate",
        "Microwave",
        "WiFi (on demand)",
        "Shower",
      ],
      descTitle: "Description",
      desc: [
        "The yacht welcomes you with a comfortable sofa and seating area, complemented by a teak table and chairs. Two large storage hatches for luggage or sports equipment.",
        "The aft platform lowers into a bathing platform — perfect for swimming. Transparent weather curtains protect from wind and rain.",
        "Bright, glass-filled interior with panoramic views. Sliding doors and lift-up window create a true open-concept layout.",
        "Fully equipped kitchen: induction cooktop, fridge with freezer, microwave and tableware for six guests. Sofa converts to double bed.",
        "Master cabin with queen-size bed convertible to two singles. Guest cabin with two singles and wardrobe. Full bathroom.",
      ],
    },
    experiences: {
      canal: {
        title: "Telemark Canal – Historic Canal Cruising",
        lead:
          "Step into the adventure and discover Norway's hidden gem: the Telemark Canal — a historic waterway and living proof that industrial heritage can exist in harmony with nature.",
        body:
          "Enjoy the journey aboard one of our fully electric Greenline yachts, combining modern comfort with effortless, silent cruising. Along the way, find the perfect balance of outdoor activities, sightseeing and unwinding.",
        toursTitle: "Popular tours",
        tours: [
          { title: "7-night Telemark Canal with Greenline 39", price: "From EUR 2521", days: ["Day 1 – Porsgrunn – Ulefoss", "Day 2 – Ulefoss – Lunde", "Day 3 – Lunde – Kviteseid", "Day 4 – Kviteseid – Dalen", "Day 5 – Dalen – Lårdal – Lunde", "Day 6 – Lunde – Ulefoss", "Day 7 – Ulefoss – Skien", "Day 8 – Skien – Porsgrunn"] },
          { title: "7-night Telemark Canal with Greenline 33", price: "From EUR 1994", days: ["Day 1 – Porsgrunn – Ulefoss", "Day 2 – Ulefoss – Lunde", "Day 3 – Lunde – Kviteseid", "Day 4 – Kviteseid – Dalen", "Day 5 – Dalen – Lårdal – Lunde", "Day 6 – Lunde – Ulefoss", "Day 7 – Ulefoss – Skien", "Day 8 – Skien – Porsgrunn"] },
          { title: "4-night Canal and Lake Norsjø with Greenline 39", price: "From EUR 1440", days: ["Day 1 – Porsgrunn – Ulefoss", "Day 2 – Ulefoss – First Camp Norsjø", "Day 3 – First Camp Norsjø", "Day 4 – First Camp Norsjø – Skien", "Day 5 – Skien – Porsgrunn"] },
          { title: "4-night Canal and Lake Norsjø with Greenline 33", price: "From EUR 1139", days: ["Day 1 – Porsgrunn – Ulefoss", "Day 2 – Ulefoss – First Camp Norsjø", "Day 3 – First Camp Norsjø", "Day 4 – First Camp Norsjø – Skien", "Day 5 – Skien – Porsgrunn"] },
          { title: "3-night Canal Escape with Greenline 39", price: "From EUR 1080", days: ["Day 1 – Porsgrunn – Ulefoss", "Day 2 – Ulefoss", "Day 3 – Ulefoss – Skien", "Day 4 – Skien – Porsgrunn"] },
          { title: "3-night Canal Escape with Greenline 33", price: "From EUR 855", days: ["Day 1 – Porsgrunn – Ulefoss", "Day 2 – Ulefoss", "Day 3 – Ulefoss – Skien", "Day 4 – Skien – Porsgrunn"] },
        ],
        cta: "Book your adventure now",
      },
      coastline: {
        title: "Coastline Adventure on the Norwegian Riviera",
        lead: "Explore the beautiful Norwegian coastline from Porsgrunn to Kragerø – through fjords, archipelagos and picturesque coastal towns.",
        body: "Ideal for those who want sun, swimming, quiet coves and the experience of Norwegian coastal life. Navigate at your own pace through Langesund, Brevik, Kragerø, Risør and Tvedestrand.",
        highlights: ["Eco-Luxury Escape", "Vibrant Norwegian Coastline", "Fjords, Islands and Archipelagos", "Spa and Relaxation"],
      },
      allInOne: {
        title: "All-in-One: Fjords, Coastline & Canal",
        lead: "The ultimate journey: combine the historic Telemark Canal with a coastal escape in one unforgettable holiday.",
        body: "Perfect for active explorers who want to see it all. Recommended duration is two weeks to fully enjoy both landscapes.",
        highlights: ["For Active Explorers", "Stunning Inland Waterway", "Picturesque Coastal Towns", "Nature and Sightseeing"],
      },
    },
    about: {
      eyebrow: "About us",
      title: "Electric yacht charter — your adventure starts with Canal Boats Telemark!",
      lead:
        "We invite you on an amazing adventure to discover Telemark – a region on the southern coast of Norway – aboard an eco-friendly electric yacht. We are the world's first electric yacht charter company, with a fleet powered entirely by renewable energy.",
      pillars: [
        { title: "Location", body: "Telemark is a unique place where you will experience constantly changing landscapes, from rocky fjord coastlines to the man-made Telemark Canal, against crystal-clear lakes and dense forests." },
        { title: "Fleet", body: "See how harmony with nature can go hand-in-hand with luxurious comfort. A quiet, zero-emission boat, fully equipped to a premium standard." },
        { title: "Experience", body: "Discover a new quality of yachting aboard an electric pleasure craft in incredible natural surroundings. Take a deep breath, relax, and enjoy your holiday." },
      ],
      storyTitle: "Our Story",
      storySub: "What inspired us?",
      storyText: [
        "My name is Ernst Terje, and in 2020 I founded Canal Boats Telemark with a clear vision: to create something meaningful in Porsgrunn — my hometown — and to share the beauty of one of the world's most remarkable waterways.",
        "Growing up in Kragerø, my connection to the sea began early. By the time I was sixteen, my summers were spent on the water, learning by doing.",
        "At thirty, I bought my first 34 ft boat. Years later, at forty-six, I set out on the adventure of a lifetime aboard the Princess V46 — cruising from Norway to the Mediterranean through Europe's historic canal system.",
        "The journey became the best holiday of my life. After four years and four months, I returned to Norway with unforgettable memories — and a new idea I couldn't let go of. That journey became the foundation of Canal Boats Telemark.",
      ],
      quote: "The journey became the best holiday of my life — and after four years and four months, I returned with unforgettable memories.",
      baseTitle: "Our Base",
      baseSub: "We are located in Porsgrunn, Telemark",
      baseBullets: [
        "35 minutes by car or train from Oslo Torp Airport (TRF)",
        "2 hours by car or train from Oslo Gardermoen Airport (OSL)",
        "Via the E18 motorway from ferry ports in Kristiansand, Larvik or Sandefjord",
      ],
      baseBody:
        "Marina is located by the riverside in the city center, just 5 minutes walking distance from the train station. The office is located 150 m from the marina.",
    },
    faq: {
      eyebrow: "Questions & Answers",
      title: "Frequently Asked Questions",
      subtitle: "Answers to the most frequent questions about boat rental",
      intro:
        "If you can't find what you're looking for, just reach out — we're happy to help you plan the perfect holiday.",
      searchPlaceholder: "Search the FAQ…",
      contactCta: "Still have a question? Contact us",
      categories: [
        {
          name: "1. BOAT EXPERIENCE",
          items: [
            { q: "Do you have to have a boat driver's license to rent a boat?", a: "In Norway, boating license requirements depend on year of birth. If you were born in 1980 or later, you must hold a valid boating license. Our safety requirement (applies to everyone): at least two seasons of boating experience. Foreign EEA licenses generally accepted. ICC accepted only if it includes coastal navigation (Resolution 40). Feel free to send us a scan for verification." },
            { q: "Do I get any training?", a: "We give a thorough introduction upon arrival (~1 hour): safety routines, boat equipment, captain's console and practical tips. An optional 2-hour training session with our captain is available as an extra." },
            { q: "What are the speed limits?", a: "5 knots close to land (within 50 m). On the Telemark Canal: 5 knots. In coastal waters: same limit near land. At 5 knots you have ~10 hours of cruising range; maximum speed is 10 knots." },
            { q: "Can I pay to bring a skipper on board?", a: "We do not offer a skipper service for weekly cruises, but a 2-hour training session with our captain is available as an extra. Day trips with a captain may be possible – contact post@canalboats.no." },
          ],
        },
        {
          name: "2. BOOKING",
          items: [
            { q: "How can I book a boat?", a: "Use our booking calendar to find dates. Select preferred dates, boat model and optional extras. A mandatory cleaning fee is always added. You can also book by email, phone or chat. Check-in and check-out days are Monday to Saturday. Minimum rental period is 2 nights." },
            { q: "When is check-in and check-out?", a: "Check-in: 14:00 (paperwork + boat introduction takes ~1 hour). Check-out: 10:00. Please put all equipment back and dispose of trash before leaving." },
            { q: "Early check-in or late check-out?", a: "Standard times are 14:00 in / 10:00 out. Contact us — we'll do our best depending on schedule." },
            { q: "Where do I pick up the boat?", a: "At Canal Boats Telemark's marina in Porsgrunn (Porsgrunn Guest Marina). Meet us at the office at Stangsgate 1, ~150 m from the marina." },
            { q: "Age limit for renting?", a: "The captain must be at least 25 years old." },
            { q: "What's included in the rental price?", a: "Included: boat rental, onboard equipment (life jackets, ropes, fenders), fully equipped kitchen, bed linen and towels, basic consumables, teak table/chairs, insurance, Telemark Canal lock tickets for 2026. Not included: refundable deposit / damage waiver, mandatory cleaning fee (EUR 250), extras (WiFi, SUP, parking), charging costs (~EUR 42–84 per week)." },
            { q: "Towels and linen included?", a: "Yes — bed linen and towels for all guests included. Extras available for a small fee." },
            { q: "Can I order extras later?", a: "Yes — contact us by email or phone, payment upon arrival. Best availability for parking/WiFi if booked in advance." },
          ],
        },
        {
          name: "3. PAYMENT",
          items: [
            { q: "How much does it cost?", a: "Use our booking widget – price shown automatically. Seasons: High season 21.06–14.08. Medium season 01.05–20.06 and 15.08–04.10. Low season 01.04–30.04 and 05.10–01.11." },
            { q: "Payment options?", a: "Pay full amount at booking, or split in two: 35% at confirmation, remaining 65% no later than 42 days before your holiday. Card via our booking system; bank transfer on request." },
            { q: "Which payment methods?", a: "Visa, Mastercard, PayPal, Google Pay. Bank transfer available on request. Account: Sparebanken Sør – 2801 55 18539, IBAN NO7928015518539, Swift SPSONO22XXX." },
            { q: "How much is the deposit?", a: "EUR 3,000, payable at check-in by card or cash. Refunded within 7 working days after check-out if boat undamaged. Note 3.6% bank fee on card payments." },
            { q: "Can I buy a damage waiver?", a: "Yes — optional damage waiver (reduces liability) costs EUR 460 (non-refundable)." },
          ],
        },
        {
          name: "4. CHARGING AND INFRASTRUCTURE",
          items: [
            { q: "Where can I charge the boat?", a: "At any marina with standard 16A charging – available at most jetties in Telemark. Fast chargers (21 kW) along the canal and in Kragerø." },
            { q: "How much does charging cost?", a: "Usually included in the harbour fee; some places may have a separate charge, and fast chargers have their own pricing. Check GoMarina or Marina Booking apps." },
            { q: "How long does charging take?", a: "Fast charging (400V/32A): ~3 hours to 80%. Standard (230V/16A): overnight. A typical cruising day (5 hours) uses ~50% of the battery." },
            { q: "Longest distance between charging points?", a: "Between Kviteseid and Lunde – ~23.7 nm (~43 km). Fast chargers at both marinas." },
            { q: "Range of the boat?", a: "At 5 knots you can travel ~100 km (57.6 nm) – ~10 hours of cruising. Solar panels supply only the 12V house systems." },
          ],
        },
        {
          name: "5. GENERAL INFORMATION",
          items: [
            { q: "What should I bring?", a: "Comfortable non-slip boat shoes and waterproof clothing. Gloves useful at locks. Several shops within walking distance. No need to bring water containers – drinking water available at the marina." },
            { q: "Is fishing allowed?", a: "Yes with local rules. Canal has trout, perch, char, whitefish, pike, tench. Everyone over 16 needs a valid fishing license. Salmon/sea trout only 1 June – 30 Sept, max 2/day/person. Licenses via inatur.no." },
            { q: "Where do I empty the septic tank?", a: "Canal: Hjellebrygga, Ulefoss, Kviteseid, Dalen, Akkerhaugen West. Coast: Porsgrunn, Brevik, Langesund, Kragerø. Emptying in water is strictly forbidden." },
            { q: "How many locks on the Telemark Canal?", a: "8 lock systems with 18 lock chambers: Skien, Løveid, Ulefoss, Eidsfoss, Vrangfoss, Lunde, Kjeldal, Hogga. The canal is 105 km long with a total lift height of 72 m." },
            { q: "Lock ticket cost?", a: "For the 2026 season, Telemark Canal lock tickets are INCLUDED in your rental – no extra fees!" },
            { q: "How long does the Telemark Canal take?", a: "We recommend one week for the full canal at a relaxed pace. Canal + coast: at least two weeks." },
            { q: "How do we pass through a lock?", a: "One person at bow, one at stern. Lock keeper passes you mooring ropes to secure. We explain the procedure at check-in." },
            { q: "When are the locks open?", a: "21 June – 14 August. Daily 09:00–18:00. July is busiest – arrive early (~08:30). Passenger vessels (MS Victoria and MS Ibsen) have priority. Outside season: possible with prior arrangement via the canal office." },
          ],
        },
        {
          name: "6. LOCATION AND DISTANCE TO MAIN BASE",
          items: [
            { q: "Where are you located?", a: "Porsgrunn in Telemark, Norway. Headquarter: Stangsgate 1, 3915 Porsgrunn. The guest marina is 150 m from the office." },
            { q: "How do I get to Porsgrunn?", a: "From Oslo Gardermoen (OSL) or Oslo Torp (TRF). By car ~2.5h from Oslo, 35 min from Torp. Direct train recommended – similar duration. Multiple parking garages; we also offer indoor parking for an extra fee." },
            { q: "Accommodation in Porsgrunn?", a: "We recommend Vic Hotel – central, short walk from the marina. Book via vichotel.no with code CANBO for 15% discount." },
            { q: "Where can I go with the boat?", a: "We recommend our suggested routes: Telemark Canal, Coastline or All-in-One. All journeys start and end in Porsgrunn." },
            { q: "Any restrictions on where I can drive?", a: "No – as long as you return the boat to Porsgrunn on time, you're free to explore anywhere within the cruising area." },
          ],
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Get in touch",
      sub: "We're happy to help you plan the perfect holiday.",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone (optional)",
        subject: "Subject",
        message: "Message",
        send: "Send message",
        sent: "Thank you! We'll reply as soon as possible.",
        error: "Could not send – please try again or email us directly.",
      },
      infoTitle: "Contact information",
      officeHours: "Office hours",
      officeHoursValue: "Mon–Sat 09:00–17:00",
    },
    book: {
      eyebrow: "Book your trip",
      title: "Check availability and send a booking request",
      sub: "Pick dates and boat model – we confirm within 24 hours.",
      startDate: "Start date",
      endDate: "End date",
      guests: "Number of guests",
      boat: "Preferred boat",
      any: "Any",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      message: "Message (optional)",
      submit: "Send booking request",
      success: "Thank you! We'll be in touch within 24 hours to confirm.",
      error: "Could not send – please try again.",
      availableTitle: "Availability next 7 days",
      loading: "Loading availability…",
    },
  },

  de: {
    nav: {
      home: "Startseite",
      fleet: "Unsere Flotte",
      experiences: "Erlebnisse",
      canal: "Telemarkkanal",
      coastline: "Küste",
      allInOne: "Alles-in-Einem",
      about: "Über uns",
      faq: "FAQ",
      contact: "Kontakt",
      book: "Jetzt buchen",
      login: "Kunden-Login",
    },
    footer: {
      tagline: "Die weltweit erste vollelektrische Charter-Flotte in Telemark.",
      address: "Stangsgate 1, 3915 Porsgrunn, Norwegen",
      phone: "+47 900 21 105",
      email: "post@canalboats.no",
      privacy: "Datenschutz",
      copyright: "© 2026 Canal Boats Telemark. Alle Rechte vorbehalten.",
      contactUs: "Kontakt",
      quickLinks: "Schnellzugriff",
    },
    home: {
      eyebrow: "Umweltfreundliche Bootsvermietung in Telemark",
      heroTitle: "Buchen Sie Ihre Yacht und entdecken Sie Norwegens beeindruckende Wasserwege!",
      heroSub: "Wählen Sie ein Datum und starten Sie:",
      ctaAvailability: "Verfügbarkeit prüfen",
      ctaFleet: "Zur Flotte",
      ctaAbout: "Über uns",
      section2Title: "Öko-Luxus Yachting für den modernen Entdecker",
      section2Body:
        "Lernen Sie die weltweit erste elektrische Charter-Flotte kennen, wo Luxus und Nachhaltigkeit zusammenkommen. Mieten Sie eine Yacht, die zu 100 % mit erneuerbarer Energie betrieben wird, und entdecken Sie Telemark.",
      pillars: [
        { title: "Norwegen im Kleinformat entdecken", body: "Entspannen Sie auf einer eleganten Elektroyacht durch die malerischen Wasserwege Telemarks." },
        { title: "Neue Qualität des Bootslebens", body: "Kein Motorenlärm, kein Dieselgeruch. Genießen Sie die Natur mit allen Sinnen." },
        { title: "Umweltfreundliche Motoryachten", body: "Leiser, emissionsfreier Antrieb – unsere Boote bewegen sich im Einklang mit der Natur." },
        { title: "Luxus und Nachhaltigkeit", body: "Laden Sie Ihre Liebsten zu einer luxuriösen Reise in Harmonie mit der Natur ein." },
      ],
      fleetTitle: "Elektrische Flotte",
      fleetIntro:
        "Die weltweit erste elektrische Bootsvermietung lädt Sie zum Abenteuer ein. Übernehmen Sie das Ruder einer Greenline Elektro-Kabinenkreuzer.",
      fleetBody:
        "Entdecken Sie Norwegen vom Wasser aus – gleiten Sie leise durch historischen Kanal, Seen und atemberaubende Küste.",
      toursTitle: "Erleben Sie Norwegen im Kleinformat!",
      toursSub: "Unsere Touren – Telemark ist der Ort, wo Sie den historischen Telemarkkanal, majestätische Fjorde und eine Küste voller Inseln erleben.",
      tourCards: [
        { tag: "Küste", title: "Küstenabenteuer auf der Norwegischen Riviera", bullets: ["Öko-Luxus", "Lebendige norwegische Küste", "Fjorde, Inseln und Schären", "Spa und Erholung"] },
        { tag: "Telemarkkanal", title: "Telemarkkanal – Norwegens verborgene Perle", bullets: ["Perfekt für Outdoor-Fans", "Friedliche Entspannung", "Historische Kanalroute", "Aktivitäten und Ruhe"] },
        { tag: "Alles-in-Einem", title: "Alles-in-Einem: Fjorde, Küste & Telemarkkanal", bullets: ["Für aktive Entdecker", "Atemberaubende Binnengewässer", "Malerische Küstenstädte", "Natur und Sightseeing"] },
      ],
      reviewsTitle: "Ihre Meinung zählt",
      reviewsBased: "Basierend auf 19 Bewertungen",
      excellent: "AUSGEZEICHNET",
    },
    fleet: {
      eyebrow: "Unsere Flotte",
      title: "Verbringen Sie Ihren Urlaub an Bord der weltweit ersten vollelektrischen Charter-Flotte!",
      intro1: "Bereit für die Reise?",
      intro2:
        "Unsere Flotte umfasst sechs moderne Greenline-Yachten (2021), verfügbar als Bareboat-Charter ab Porsgrunn in Telemark, Norwegen.",
      intro3:
        "Jede Yacht wird von einem 50 kW (68 PS) E-Drive Elektromotor angetrieben und kann über eine standardmäßige 230V-Landstromdose geladen werden. Auch Schnelllader sind entlang des Kanals und in Kragerø verfügbar.",
      intro4:
        "Elektroantrieb bedeutet keine Abgase und minimalen Lärm – nur das Wasser, die Landschaft und Ihr eigenes Tempo.",
      chooseTitle: "Wählen Sie Ihr Lieblingsmodell",
      chooseSub: "Wählen Sie die Greenline, die zu Ihrem Urlaubsstil passt – abenteuerlustig oder komfortorientiert.",
      bookNow: "Jetzt buchen",
      checkAvail: "Verfügbarkeit prüfen",
    },
    gl33: {
      title: "Greenline 33",
      subtitle: "Preisgekröntes Elektroboot, perfekt für Familienurlaub oder Reisen zu zweit.",
      lead:
        "Greenline 33 ist ein stilvolles und preisgekröntes Elektroboot, in der Branche für Design und Innovation bekannt. Elegant und leicht zu manövrieren.",
      pickup: "Bitte beachten: Übernahmetage sind Dienstag und Donnerstag.",
      specsTitle: "Technische Daten",
      specs: [
        "Anzahl Schlafplätze: 7",
        "Gesamtkapazität: 10 Personen",
        "Bug- und Heckstrahlruder",
        "Elektrische Ankerwinsch",
        "Sonnenliegen am Bug",
        "Badeplattform",
        "Voll ausgestattete Küche",
        "Kühlschrank und Gefrierfach",
        "Induktionskochfeld",
        "Mikrowelle",
        "WLAN (auf Anfrage)",
        "Dusche",
        "Toilette",
        "Klimaanlage",
        "Warmwasserbereiter",
        "300 l Frischwassertank",
        "140 l Fäkalientank",
        "Feueralarm",
      ],
      descTitle: "Beschreibung",
      desc: [
        "Betreten Sie das Boot über das großzügige Achterdeck. Komfortable Sitzgelegenheiten, Teak-Tisch und großzügiger Stauraum. Schiebetüren führen ins helle Innere.",
        "Modernes skandinavisches Design trifft auf Funktion. Ein Hebefenster verbindet die Küche direkt mit dem Achterdeck.",
        "Innenraum mit zwei Sofas, verstellbarem Tisch und 360°-Panoramafenstern. Ein Sofa wandelt sich in ein Bett um.",
        "Master-Kabine: Queen-Bett wandelbar zu zwei Einzelbetten, Stauraum, Etagenbett für Familien. Vollausgestattetes Bad.",
      ],
    },
    gl39: {
      title: "Greenline 39",
      subtitle: "Elegante Elektroyacht mit edlem Interieur und Premium-Erlebnis.",
      lead:
        "Greenline 39 ist eine wirklich komfortable und elegante Elektroyacht, gestaltet für Reisende, die Platz, Stil und unkompliziertes Cruisen schätzen.",
      pickup: "Bitte beachten: Übernahmetage sind Montag, Mittwoch, Freitag und Samstag.",
      specsTitle: "Technische Daten",
      specs: [
        "Anzahl Schlafplätze: 6",
        "Gesamtkapazität: 10 Personen",
        "Bug- und Heckstrahlruder",
        "Elektrische Ankerwinsch",
        "Sonnenliegen am Bug",
        "Badeplattform",
        "Pilottür an Steuerbord",
        "Voll ausgestattete Küche",
        "Kühlschrank und Gefrierfach",
        "Induktionskochfeld",
        "Mikrowelle",
        "WLAN (auf Anfrage)",
        "Dusche",
      ],
      descTitle: "Beschreibung",
      desc: [
        "Die Yacht empfängt Sie mit einem komfortablen Sofa und Sitzbereich, ergänzt durch Teak-Tisch und Stühle.",
        "Die Achterplattform lässt sich zur Badeplattform absenken. Transparente Wettervorhänge schützen vor Wind und Regen.",
        "Helles, glasgefülltes Inneres mit Panoramablick. Schiebetüren und Hebefenster schaffen ein offenes Konzept.",
        "Voll ausgestattete Küche mit Induktion, Kühlschrank, Mikrowelle und Geschirr für sechs. Sofa wandelbar zum Doppelbett.",
        "Master-Kabine mit Queen-Bett, Gästekabine mit zwei Einzelbetten, komplettes Bad.",
      ],
    },
    experiences: {
      canal: {
        title: "Telemarkkanal – Historisches Kanal-Cruisen",
        lead:
          "Steigen Sie in das Abenteuer ein und entdecken Sie Norwegens verborgene Perle: den Telemarkkanal.",
        body:
          "Genießen Sie die Reise an Bord unserer vollelektrischen Greenline-Yachten – moderner Komfort und leises Gleiten.",
        toursTitle: "Beliebte Touren",
        tours: [
          { title: "7-Nächte Telemarkkanal mit Greenline 39", price: "Ab EUR 2521", days: ["Tag 1 – Porsgrunn – Ulefoss", "Tag 2 – Ulefoss – Lunde", "Tag 3 – Lunde – Kviteseid", "Tag 4 – Kviteseid – Dalen", "Tag 5 – Dalen – Lårdal – Lunde", "Tag 6 – Lunde – Ulefoss", "Tag 7 – Ulefoss – Skien", "Tag 8 – Skien – Porsgrunn"] },
          { title: "7-Nächte Telemarkkanal mit Greenline 33", price: "Ab EUR 1994", days: ["Tag 1 – Porsgrunn – Ulefoss", "Tag 2 – Ulefoss – Lunde", "Tag 3 – Lunde – Kviteseid", "Tag 4 – Kviteseid – Dalen", "Tag 5 – Dalen – Lårdal – Lunde", "Tag 6 – Lunde – Ulefoss", "Tag 7 – Ulefoss – Skien", "Tag 8 – Skien – Porsgrunn"] },
          { title: "4-Nächte Kanal und Norsjø mit Greenline 39", price: "Ab EUR 1440", days: ["Tag 1 – Porsgrunn – Ulefoss", "Tag 2 – Ulefoss – First Camp Norsjø", "Tag 3 – First Camp Norsjø", "Tag 4 – First Camp Norsjø – Skien", "Tag 5 – Skien – Porsgrunn"] },
          { title: "4-Nächte Kanal und Norsjø mit Greenline 33", price: "Ab EUR 1139", days: ["Tag 1 – Porsgrunn – Ulefoss", "Tag 2 – Ulefoss – First Camp Norsjø", "Tag 3 – First Camp Norsjø", "Tag 4 – First Camp Norsjø – Skien", "Tag 5 – Skien – Porsgrunn"] },
          { title: "3-Nächte Kanal-Escape mit Greenline 39", price: "Ab EUR 1080", days: ["Tag 1 – Porsgrunn – Ulefoss", "Tag 2 – Ulefoss", "Tag 3 – Ulefoss – Skien", "Tag 4 – Skien – Porsgrunn"] },
          { title: "3-Nächte Kanal-Escape mit Greenline 33", price: "Ab EUR 855", days: ["Tag 1 – Porsgrunn – Ulefoss", "Tag 2 – Ulefoss", "Tag 3 – Ulefoss – Skien", "Tag 4 – Skien – Porsgrunn"] },
        ],
        cta: "Buchen Sie jetzt Ihr Abenteuer",
      },
      coastline: {
        title: "Küstenabenteuer auf der Norwegischen Riviera",
        lead: "Entdecken Sie die norwegische Küste von Porsgrunn bis Kragerø – durch Fjorde, Schären und malerische Küstenstädte.",
        body: "Ideal für Sonne, Baden, ruhige Buchten und norwegisches Küstenleben. Navigieren Sie in Ihrem Tempo durch Langesund, Brevik, Kragerø, Risør und Tvedestrand.",
        highlights: ["Öko-Luxus", "Lebendige Küste", "Fjorde, Inseln und Schären", "Spa und Erholung"],
      },
      allInOne: {
        title: "Alles-in-Einem: Fjorde, Küste & Kanal",
        lead: "Die ultimative Reise: Kombinieren Sie den historischen Telemarkkanal mit einem Küstenausflug.",
        body: "Perfekt für aktive Entdecker. Empfohlene Dauer: zwei Wochen, um beide Landschaften voll zu genießen.",
        highlights: ["Für aktive Entdecker", "Atemberaubende Binnengewässer", "Malerische Küstenstädte", "Natur und Sightseeing"],
      },
    },
    about: {
      eyebrow: "Über uns",
      title: "Elektro-Yachtcharter — Ihr Abenteuer beginnt mit Canal Boats Telemark!",
      lead:
        "Wir laden Sie zu einem großartigen Abenteuer ein, um Telemark – eine Region an Norwegens Südküste – an Bord einer umweltfreundlichen Elektroyacht zu entdecken. Wir sind das weltweit erste Elektro-Yachtcharter-Unternehmen mit einer Flotte, die vollständig mit erneuerbarer Energie betrieben wird.",
      pillars: [
        { title: "Lage", body: "Telemark ist ein einzigartiger Ort, an dem Sie ständig wechselnde Landschaften erleben – von felsigen Fjordküsten bis zum menschengemachten Telemarkkanal." },
        { title: "Flotte", body: "Sehen Sie, wie Harmonie mit der Natur und luxuriöser Komfort Hand in Hand gehen können." },
        { title: "Erlebnis", body: "Entdecken Sie eine neue Qualität des Yachtens auf einem Elektroboot in unglaublicher natürlicher Umgebung." },
      ],
      storyTitle: "Unsere Geschichte",
      storySub: "Was inspirierte uns?",
      storyText: [
        "Ich heiße Ernst Terje und gründete 2020 Canal Boats Telemark mit einer klaren Vision: etwas Sinnvolles in Porsgrunn – meiner Heimatstadt – zu schaffen.",
        "In Kragerø aufgewachsen, begann meine Verbindung zum Meer früh. Mit 16 verbrachte ich meine Sommer auf dem Wasser.",
        "Mit 30 kaufte ich mein erstes 34-Fuß-Boot. Jahre später, mit 46, ging ich auf das Abenteuer meines Lebens an Bord der Princess V46.",
        "Die Reise wurde der beste Urlaub meines Lebens. Nach vier Jahren und vier Monaten kehrte ich mit unvergesslichen Erinnerungen nach Norwegen zurück – und einer neuen Idee, die zur Grundlage von Canal Boats Telemark wurde.",
      ],
      quote: "Die Reise wurde der beste Urlaub meines Lebens — und nach vier Jahren und vier Monaten kehrte ich mit unvergesslichen Erinnerungen zurück.",
      baseTitle: "Unsere Basis",
      baseSub: "Wir befinden uns in Porsgrunn, Telemark",
      baseBullets: [
        "35 Minuten mit Auto oder Zug vom Flughafen Oslo Torp (TRF)",
        "2 Stunden mit Auto oder Zug vom Flughafen Oslo Gardermoen (OSL)",
        "Über die E18 aus Kristiansand, Larvik oder Sandefjord",
      ],
      baseBody:
        "Die Marina liegt am Flussufer im Stadtzentrum, nur 5 Gehminuten vom Bahnhof entfernt. Das Büro liegt 150 m von der Marina.",
    },
    faq: {
      eyebrow: "Fragen & Antworten",
      title: "Häufig gestellte Fragen",
      subtitle: "Antworten zu den häufigsten Fragen zur Bootsvermietung",
      intro:
        "Wenn Sie nicht finden, was Sie suchen, kontaktieren Sie uns — wir helfen gerne bei der Planung.",
      searchPlaceholder: "FAQ durchsuchen…",
      contactCta: "Noch Fragen? Kontaktieren Sie uns",
      categories: [
        {
          name: "1. BOOT-ERLEBNIS",
          items: [
            { q: "Brauche ich einen Bootsführerschein?", a: "In Norwegen abhängig vom Geburtsjahr. Ab 1980 geboren: gültiger Bootsführerschein erforderlich. Unser Sicherheitskriterium (für alle): mindestens zwei Saisons Bootserfahrung. Ausländische EWR-Lizenzen im Allgemeinen akzeptiert. ICC nur mit Küstennavigation (Resolution 40). Bei Unsicherheit senden Sie uns einen Scan – wir prüfen kostenlos." },
            { q: "Bekomme ich eine Einweisung?", a: "Wir geben eine gründliche Einweisung bei Ankunft (~1 Stunde): Sicherheit, Ausstattung, Konsole und Praxis-Tipps. Optional 2-Stunden-Training mit unserem Kapitän als Extra." },
            { q: "Was sind die Geschwindigkeitsgrenzen?", a: "5 Knoten in Landnähe (innerhalb 50 m). Auf dem Telemarkkanal: 5 Knoten. In Küstengewässern gleiche Grenze in Landnähe. Bei 5 Knoten ~10 Stunden Reichweite; Höchstgeschwindigkeit 10 Knoten." },
            { q: "Kann ich einen Skipper buchen?", a: "Wir bieten keinen Skipper für Wochenchartern, aber 2-Stunden-Training mit dem Kapitän ist möglich. Tagestouren mit Kapitän: post@canalboats.no." },
          ],
        },
        {
          name: "2. BUCHUNG",
          items: [
            { q: "Wie buche ich?", a: "Nutzen Sie unseren Buchungskalender. Wählen Sie Daten, Modell und optionale Extras. Eine obligatorische Reinigungsgebühr wird immer hinzugefügt. Anfrage per E-Mail, Telefon oder Chat möglich. Check-in/Check-out Mo–Sa. Mindestmietdauer: 2 Nächte." },
            { q: "Wann Check-in und Check-out?", a: "Check-in: 14:00 (Papiere + Einweisung ~1 Std). Check-out: 10:00. Ausrüstung zurücklegen, Müll entsorgen." },
            { q: "Früherer Check-in oder späterer Check-out?", a: "Standard 14:00 rein / 10:00 raus. Kontaktieren Sie uns — wir tun unser Bestes je nach Auslastung." },
            { q: "Wo hole ich das Boot ab?", a: "An der Marina Canal Boats Telemark in Porsgrunn (Gastmarina). Büro: Stangsgate 1, ~150 m von der Marina." },
            { q: "Altersgrenze zum Mieten?", a: "Der Kapitän muss mindestens 25 Jahre alt sein." },
            { q: "Was ist im Mietpreis enthalten?", a: "Enthalten: Bootsmiete, Ausrüstung (Schwimmwesten, Leinen, Fender), Küche, Bettwäsche und Handtücher, Grundverbrauch, Teak-Möbel, Versicherung, Kanalschleusen-Tickets 2026. Nicht enthalten: Kaution/Schadenverzicht, obligatorische Reinigungsgebühr (250 EUR), Extras (WLAN, SUP, Parken), Ladekosten (~42–84 EUR/Woche)." },
            { q: "Handtücher und Bettwäsche enthalten?", a: "Ja — für alle Gäste enthalten. Extras für kleine Gebühr." },
            { q: "Kann ich Extras nachträglich bestellen?", a: "Ja — per E-Mail oder Telefon, Zahlung bei Ankunft. Innenparken/WLAN am besten vorab buchen." },
          ],
        },
        {
          name: "3. BEZAHLUNG",
          items: [
            { q: "Was kostet die Miete?", a: "Nutzen Sie das Buchungswidget – Preis wird automatisch angezeigt. Saisons: Hochsaison 21.06–14.08. Mittelsaison 01.05–20.06 und 15.08–04.10. Nebensaison 01.04–30.04 und 05.10–01.11." },
            { q: "Zahlungsoptionen?", a: "Voller Betrag bei Buchung oder Aufteilung in zwei Raten: 35 % bei Bestätigung, 65 % spätestens 42 Tage vor Urlaub. Karte über Buchungssystem; Banküberweisung auf Anfrage." },
            { q: "Welche Zahlungsmittel?", a: "Visa, Mastercard, PayPal, Google Pay. Banküberweisung möglich – Konto: Sparebanken Sør – 2801 55 18539, IBAN NO7928015518539, Swift SPSONO22XXX." },
            { q: "Wie hoch ist die Kaution?", a: "3.000 EUR, zahlbar bei Check-in per Karte oder Bar. Rückerstattung innerhalb 7 Werktagen nach Check-out. Kartenzahlung: 3,6 % Bankgebühr." },
            { q: "Schadenverzicht möglich?", a: "Ja — optionaler Schadenverzicht (Haftungsreduzierung) für 460 EUR (nicht erstattungsfähig)." },
          ],
        },
        {
          name: "4. LADEN UND INFRASTRUKTUR",
          items: [
            { q: "Wo kann ich das Boot laden?", a: "An jeder Marina mit Standard-16A-Ladepunkt. Schnelllader (21 kW) am Kanal und in Kragerø." },
            { q: "Was kostet das Laden?", a: "Üblicherweise in der Hafengebühr enthalten. Manchmal separate Gebühr; Schnelllader haben eigene Preise. GoMarina oder Marina Booking Apps prüfen." },
            { q: "Wie lange dauert das Laden?", a: "Schnellladen (400V/32A): ~3 Std bis 80 %. Standard (230V/16A): über Nacht. Ein typischer Cruise-Tag (5 Std) verbraucht ~50 % Batterie." },
            { q: "Längste Strecke zwischen Ladepunkten?", a: "Zwischen Kviteseid und Lunde – ~23,7 sm (~43 km). Schnelllader in beiden Marinas." },
            { q: "Reichweite des Bootes?", a: "Bei 5 Knoten ~100 km (57,6 sm) – ~10 Std. Solarpanels versorgen nur 12V-Systeme, nicht den Antrieb." },
          ],
        },
        {
          name: "5. ALLGEMEINE INFO",
          items: [
            { q: "Was sollte ich mitbringen?", a: "Rutschfeste Bootsschuhe und wasserdichte Kleidung. Handschuhe bei Schleusen nützlich. Mehrere Geschäfte in Gehnähe. Wasser-Kanister unnötig – Trinkwasser an der Marina." },
            { q: "Ist Angeln erlaubt?", a: "Ja mit lokalen Regeln. Kanal: Forelle, Barsch, Saibling, Renke, Hecht, Schleie. Ab 16 Jahren gültige Angellizenz nötig. Lachs/Meerforelle nur 1. Juni – 30. Sept, max. 2/Tag/Person. Lizenzen über inatur.no." },
            { q: "Wo entleere ich den Fäkalientank?", a: "Kanal: Hjellebrygga, Ulefoss, Kviteseid, Dalen, Akkerhaugen West. Küste: Porsgrunn, Brevik, Langesund, Kragerø. Entleerung ins Wasser strikt verboten." },
            { q: "Wie viele Schleusen auf dem Telemarkkanal?", a: "8 Schleusensysteme mit 18 Kammern: Skien, Løveid, Ulefoss, Eidsfoss, Vrangfoss, Lunde, Kjeldal, Hogga. Kanal 105 km lang, Gesamthöhe 72 m." },
            { q: "Schleusen-Ticket-Kosten?", a: "Für Saison 2026 INKLUSIVE im Mietpreis – keine extra Gebühren!" },
            { q: "Wie lange dauert der Telemarkkanal?", a: "Eine Woche entspannt für den ganzen Kanal. Kanal + Küste: mindestens zwei Wochen." },
            { q: "Wie passiert man eine Schleuse?", a: "Eine Person am Bug, eine am Heck. Schleusenwärter reicht Festmacher. Erklärung bei Check-in." },
            { q: "Wann sind die Schleusen offen?", a: "21. Juni – 14. August. Täglich 09:00–18:00. Juli am geschäftigsten – früh dort sein (~08:30). MS Victoria und MS Ibsen haben Vorrang. Außerhalb Saison: mit Voranmeldung möglich." },
          ],
        },
        {
          name: "6. LAGE UND ANFAHRT",
          items: [
            { q: "Wo sind Sie?", a: "Porsgrunn in Telemark, Norwegen. HQ: Stangsgate 1, 3915 Porsgrunn. Gastmarina 150 m vom Büro." },
            { q: "Wie komme ich nach Porsgrunn?", a: "Von Oslo Gardermoen (OSL) oder Torp (TRF). Auto ~2,5 Std von Oslo, 35 Min von Torp. Direktzug empfohlen. Mehrere Parkhäuser; Innenparken gegen Aufpreis." },
            { q: "Übernachtung in Porsgrunn?", a: "Vic Hotel empfohlen – zentral, kurze Gehstrecke zur Marina. Buchen via vichotel.no, Code CANBO für 15 % Rabatt." },
            { q: "Wohin kann ich mit dem Boot fahren?", a: "Unsere empfohlenen Routen: Telemarkkanal, Küste oder Alles-in-Einem. Alle Reisen starten/enden in Porsgrunn." },
            { q: "Fahrverbote?", a: "Nein – solange Sie das Boot pünktlich nach Porsgrunn zurückbringen, sind Sie frei." },
          ],
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Nehmen Sie Kontakt auf",
      sub: "Wir helfen gerne bei der Planung Ihres perfekten Urlaubs.",
      form: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon (optional)",
        subject: "Betreff",
        message: "Nachricht",
        send: "Nachricht senden",
        sent: "Danke! Wir antworten so schnell wie möglich.",
        error: "Konnte nicht senden – bitte erneut versuchen.",
      },
      infoTitle: "Kontaktinformationen",
      officeHours: "Öffnungszeiten",
      officeHoursValue: "Mo–Sa 09:00–17:00",
    },
    book: {
      eyebrow: "Buchen Sie Ihre Reise",
      title: "Verfügbarkeit prüfen und Buchungsanfrage senden",
      sub: "Wählen Sie Daten und Bootsmodell – wir bestätigen innerhalb von 24 Stunden.",
      startDate: "Startdatum",
      endDate: "Enddatum",
      guests: "Anzahl der Gäste",
      boat: "Bevorzugtes Boot",
      any: "Egal",
      name: "Vollständiger Name",
      email: "E-Mail",
      phone: "Telefon",
      message: "Nachricht (optional)",
      submit: "Buchungsanfrage senden",
      success: "Danke! Wir melden uns innerhalb von 24 Stunden zur Bestätigung.",
      error: "Konnte nicht senden – bitte erneut versuchen.",
      availableTitle: "Verfügbarkeit nächste 7 Tage",
      loading: "Verfügbarkeit wird geladen…",
    },
  },
};

export function getT(lang) {
  return TRANSLATIONS[lang] || TRANSLATIONS.no;
}
